import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchModels } from '@/lib/api';
import { ModelType } from '@/types/model';
type ParamsType = {
  vehicleGroupIds?: string[];
  categoryIds?: string[];
  brandIds?: string[];
  queryEnabled?: boolean;
};
const useModels = t0 => {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    vehicleGroupIds: t2,
    categoryIds: t3,
    brandIds: t4,
    queryEnabled: t5
  } = t1;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const vehicleGroupIds = t6;
  let t7;
  if ($[4] !== t3) {
    t7 = t3 === undefined ? [] : t3;
    $[4] = t3;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const categoryIds = t7;
  let t8;
  if ($[6] !== t4) {
    t8 = t4 === undefined ? [] : t4;
    $[6] = t4;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const brandIds = t8;
  const queryEnabled = t5 === undefined ? true : t5;
  let t10;
  let t9;
  if ($[8] !== brandIds || $[9] !== categoryIds || $[10] !== vehicleGroupIds) {
    t9 = ["models", vehicleGroupIds, categoryIds, brandIds];
    t10 = async () => fetchModels({
      vehicleGroupIds,
      categoryIds,
      brandIds
    });
    $[8] = brandIds;
    $[9] = categoryIds;
    $[10] = vehicleGroupIds;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  let t11;
  if ($[13] !== queryEnabled || $[14] !== t10 || $[15] !== t9) {
    t11 = {
      queryKey: t9,
      queryFn: t10,
      enabled: queryEnabled
    };
    $[13] = queryEnabled;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return useQuery(t11);
};
export default useModels;